import { render, staticRenderFns } from "./ModelView.vue?vue&type=template&id=764da7ba&scoped=true&"
import script from "./ModelView.vue?vue&type=script&lang=ts&"
export * from "./ModelView.vue?vue&type=script&lang=ts&"
import style0 from "./ModelView.vue?vue&type=style&index=0&id=764da7ba&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "764da7ba",
  null
  
)

export default component.exports